import * as mapUtils from './mapUtils'

let lockOnTarget = {
  marker: null,
  url: null,
  image: null,
  timer: null,
  angle: null
}

export const defaultVehicleIcon = 'sedan-blue.svg'

const scalingFactor = 1.0
export const assetTypes = [
  { name: 'dot-01', label: 'Dot', width: 60 * scalingFactor, height: 60 * scalingFactor, rotational: false, headingOffset: 0 },
  { name: 'pin-01', label: 'Pin', width: 100 * scalingFactor, height: 100 * scalingFactor, rotational: false, headingOffset: 0 },
  { name: 'arrow', label: 'Arrow', width: 65 * scalingFactor, height: 65 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'walking-man', label: 'Walking Man', width: 65 * scalingFactor, height: 65 * scalingFactor, rotational: true, headingOffset: 0 },
  { name: 'motorbike', label: 'Motorbike', width: 65 * scalingFactor, height: 65 * scalingFactor, rotational: true, headingOffset: 0 },
  { name: 'hatchback', label: 'Hatchback', width: 60 * scalingFactor, height: 60 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'sedan', label: 'Sedan', width: 65 * scalingFactor, height: 65 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'suv', label: 'SUV', width: 65 * scalingFactor, height: 65 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'pickup-doublecab', label: 'Pickup / Double-cab', width: 70 * scalingFactor, height: 70 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'pickup-singlecab', label: 'Pickup / Single-cab', width: 70 * scalingFactor, height: 70 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'mini-bus', label: 'Mini Bus Taxi', width: 80 * scalingFactor, height: 80 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'coe-4ton', label: 'COE 4-ton', width: 85 * scalingFactor, height: 85 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'coe-4ton-refrigerated', label: 'COE 4-ton / Refrigerated', width: 85 * scalingFactor, height: 85 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'medium-truck', label: 'Medium Truck', width: 95 * scalingFactor, height: 95 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'rv', label: 'RV', width: 90 * scalingFactor, height: 90 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'civ-bus', label: 'Civilian Bus', width: 85 * scalingFactor, height: 85 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'semi-heavy-horse', label: 'Heavy Semi Horse', width: 85 * scalingFactor, height: 85 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'coe-heavy-horse', label: 'Heavy COE Horse', width: 85 * scalingFactor, height: 85 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'coe-heavy-trailer', label: 'Heavy COE Trailer', width: 85 * scalingFactor, height: 85 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'coe-heavy-tanker', label: 'Heavy COE Tanker', width: 85 * scalingFactor, height: 85 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'semi-heavy-trailer', label: 'Heavy Semi Trailer', width: 85 * scalingFactor, height: 85 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'semi-heavy-tanker', label: 'Heavy Semi Tanker', width: 85 * scalingFactor, height: 85 * scalingFactor, rotational: true, headingOffset: 90 },
  { name: 'mining-dump-truck', label: 'Mining Dump Truck', width: 85 * scalingFactor, height: 85 * scalingFactor, rotational: true, headingOffset: 90 }
]

export let assetTypesMap = new Map()
assetTypes.forEach((assetType) => {
  assetTypesMap.set(assetType.name, assetType)
})

export const assetIcons = [
  { name: 'dot-01-white.svg', label: 'Dot (White)', color: 'white', type: 'dot-01' },
  { name: 'dot-01-grey.svg', label: 'Dot (Grey)', color: 'grey', type: 'dot-01' },
  { name: 'dot-01-bluegrey.svg', label: 'Dot (Blue-grey)', color: 'bluegrey', type: 'dot-01' },
  { name: 'dot-01-yellow.svg', label: 'Dot (Yellow)', color: 'yellow', type: 'dot-01' },
  { name: 'dot-01-orange.svg', label: 'Dot (Orange)', color: 'orange', type: 'dot-01' },
  { name: 'dot-01-red.svg', label: 'Dot (Red)', color: 'red', type: 'dot-01' },
  { name: 'dot-01-green.svg', label: 'Dot (Green)', color: 'green', type: 'dot-01' },
  { name: 'dot-01-blue.svg', label: 'Dot (Blue)', color: 'blue', type: 'dot-01' },

  { name: 'pin-01-white.svg', label: 'Pin (White)', color: 'white', type: 'pin-01' },
  { name: 'pin-01-grey.svg', label: 'Pin (Grey)', color: 'grey', type: 'pin-01' },
  { name: 'pin-01-bluegrey.svg', label: 'Pin (Blue-grey)', color: 'bluegrey', type: 'pin-01' },
  { name: 'pin-01-yellow.svg', label: 'Pin (Yellow)', color: 'yellow', type: 'pin-01' },
  { name: 'pin-01-orange.svg', label: 'Pin (Orange)', color: 'orange', type: 'pin-01' },
  { name: 'pin-01-red.svg', label: 'Pin (Red)', color: 'red', type: 'pin-01' },
  { name: 'pin-01-green.svg', label: 'Pin (Green)', color: 'green', type: 'pin-01' },
  { name: 'pin-01-blue.svg', label: 'Pin (Blue)', color: 'blue', type: 'pin-01' },

  { name: 'arrow-white.svg', label: 'Arrow (White)', color: 'white', type: 'arrow' },
  { name: 'arrow-grey.svg', label: 'Arrow (Grey)', color: 'grey', type: 'arrow' },
  { name: 'arrow-bluegrey.svg', label: 'Arrow (Blue-grey)', color: 'bluegrey', type: 'arrow' },
  { name: 'arrow-yellow.svg', label: 'Arrow (Yellow)', color: 'yellow', type: 'arrow' },
  { name: 'arrow-orange.svg', label: 'Arrow (Orange)', color: 'orange', type: 'arrow' },
  { name: 'arrow-red.svg', label: 'Arrow (Red)', color: 'red', type: 'arrow' },
  { name: 'arrow-green.svg', label: 'Arrow (Green)', color: 'green', type: 'arrow' },
  { name: 'arrow-blue.svg', label: 'Arrow (Blue)', color: 'blue', type: 'arrow' },

  { name: 'walking-man-white.svg', label: 'Walking Man (White)', color: 'white', type: 'walking-man' },
  { name: 'walking-man-grey.svg', label: 'Walking Man (Grey)', color: 'grey', type: 'walking-man' },
  { name: 'walking-man-bluegrey.svg', label: 'Walking Man (Blue-grey)', color: 'bluegrey', type: 'walking-man' },
  { name: 'walking-man-yellow.svg', label: 'Walking Man (Yellow)', color: 'yellow', type: 'walking-man' },
  { name: 'walking-man-orange.svg', label: 'Walking Man (Orange)', color: 'orange', type: 'walking-man' },
  { name: 'walking-man-red.svg', label: 'Walking Man (Red)', color: 'red', type: 'walking-man' },
  { name: 'walking-man-green.svg', label: 'Walking Man (Green)', color: 'green', type: 'walking-man' },
  { name: 'walking-man-blue.svg', label: 'Walking Man (Blue)', color: 'blue', type: 'walking-man' },

  { name: 'motorbike-white.svg', label: 'Motorbike (White)', color: 'white', type: 'motorbike' },
  { name: 'motorbike-grey.svg', label: 'Motorbike (Grey)', color: 'grey', type: 'motorbike' },
  { name: 'motorbike-bluegrey.svg', label: 'Motorbike (Blue-grey)', color: 'bluegrey', type: 'motorbike' },
  { name: 'motorbike-yellow.svg', label: 'Motorbike (Yellow)', color: 'yellow', type: 'motorbike' },
  { name: 'motorbike-orange.svg', label: 'Motorbike (Orange)', color: 'orange', type: 'motorbike' },
  { name: 'motorbike-red.svg', label: 'Motorbike (Red)', color: 'red', type: 'motorbike' },
  { name: 'motorbike-green.svg', label: 'Motorbike (Green)', color: 'green', type: 'motorbike' },
  { name: 'motorbike-blue.svg', label: 'Motorbike (Blue)', color: 'blue', type: 'motorbike' },

  { name: 'hatchback-white.svg', label: 'Hatchback (White)', color: 'white', type: 'hatchback' },
  { name: 'hatchback-grey.svg', label: 'Hatchback (Grey)', color: 'grey', type: 'hatchback' },
  { name: 'hatchback-bluegrey.svg', label: 'Hatchback (Blue-grey)', color: 'bluegrey', type: 'hatchback' },
  { name: 'hatchback-yellow.svg', label: 'Hatchback (Yellow)', color: 'yellow', type: 'hatchback' },
  { name: 'hatchback-orange.svg', label: 'Hatchback (Orange)', color: 'orange', type: 'hatchback' },
  { name: 'hatchback-red.svg', label: 'Hatchback (Red)', color: 'red', type: 'hatchback' },
  { name: 'hatchback-green.svg', label: 'Hatchback (Green)', color: 'green', type: 'hatchback' },
  { name: 'hatchback-blue.svg', label: 'Hatchback (Blue)', color: 'blue', type: 'hatchback' },

  { name: 'sedan-white.svg', label: 'Sedan (White)', color: 'white', type: 'sedan' },
  { name: 'sedan-grey.svg', label: 'Sedan (Grey)', color: 'grey', type: 'sedan' },
  { name: 'sedan-bluegrey.svg', label: 'Sedan (Blue-grey)', color: 'bluegrey', type: 'sedan' },
  { name: 'sedan-yellow.svg', label: 'Sedan (Yellow)', color: 'yellow', type: 'sedan' },
  { name: 'sedan-orange.svg', label: 'Sedan (Orange)', color: 'orange', type: 'sedan' },
  { name: 'sedan-red.svg', label: 'Sedan (Red)', color: 'red', type: 'sedan' },
  { name: 'sedan-green.svg', label: 'Sedan (Green)', color: 'green', type: 'sedan' },
  { name: 'sedan-blue.svg', label: 'Sedan (Blue)', color: 'blue', type: 'sedan' },

  { name: 'suv-white.svg', label: 'SUV (White)', color: 'white', type: 'suv' },
  { name: 'suv-grey.svg', label: 'SUV (Grey)', color: 'grey', type: 'suv' },
  { name: 'suv-bluegrey.svg', label: 'SUV (Blue-grey)', color: 'bluegrey', type: 'suv' },
  { name: 'suv-yellow.svg', label: 'SUV (Yellow)', color: 'yellow', type: 'suv' },
  { name: 'suv-orange.svg', label: 'SUV (Orange)', color: 'orange', type: 'suv' },
  { name: 'suv-red.svg', label: 'SUV (Red)', color: 'red', type: 'suv' },
  { name: 'suv-green.svg', label: 'SUV (Green)', color: 'green', type: 'suv' },
  { name: 'suv-blue.svg', label: 'SUV (Blue)', color: 'blue', type: 'suv' },

  { name: 'pickup-doublecab-white.svg', label: 'Pickup / Double-cab (White)', color: 'white', type: 'pickup-doublecab' },
  { name: 'pickup-doublecab-grey.svg', label: 'Pickup / Double-cab (Grey)', color: 'grey', type: 'pickup-doublecab' },
  { name: 'pickup-doublecab-bluegrey.svg', label: 'Pickup / Double-cab (Blue-grey)', color: 'bluegrey', type: 'pickup-doublecab' },
  { name: 'pickup-doublecab-yellow.svg', label: 'Pickup / Double-cab (Yellow)', color: 'yellow', type: 'pickup-doublecab' },
  { name: 'pickup-doublecab-orange.svg', label: 'Pickup / Double-cab (Orange)', color: 'orange', type: 'pickup-doublecab' },
  { name: 'pickup-doublecab-red.svg', label: 'Pickup / Double-cab (Red)', color: 'red', type: 'pickup-doublecab' },
  { name: 'pickup-doublecab-green.svg', label: 'Pickup / Double-cab (Green)', color: 'green', type: 'pickup-doublecab' },
  { name: 'pickup-doublecab-blue.svg', label: 'Pickup / Double-cab (Blue)', color: 'blue', type: 'pickup-doublecab' },

  { name: 'pickup-singlecab-white.svg', label: 'Pickup / Single-cab (White)', color: 'white', type: 'pickup-singlecab' },
  { name: 'pickup-singlecab-grey.svg', label: 'Pickup / Single-cab (Grey)', color: 'grey', type: 'pickup-singlecab' },
  { name: 'pickup-singlecab-bluegrey.svg', label: 'Pickup / Single-cab (Blue-grey)', color: 'bluegrey', type: 'pickup-singlecab' },
  { name: 'pickup-singlecab-yellow.svg', label: 'Pickup / Single-cab (Yellow)', color: 'yellow', type: 'pickup-singlecab' },
  { name: 'pickup-singlecab-orange.svg', label: 'Pickup / Single-cab (Orange)', color: 'orange', type: 'pickup-singlecab' },
  { name: 'pickup-singlecab-red.svg', label: 'Pickup / Single-cab (Red)', color: 'red', type: 'pickup-singlecab' },
  { name: 'pickup-singlecab-green.svg', label: 'Pickup / Single-cab (Green)', color: 'green', type: 'pickup-singlecab' },
  { name: 'pickup-singlecab-blue.svg', label: 'Pickup / Single-cab (Blue)', color: 'blue', type: 'pickup-singlecab' },

  { name: 'mini-bus-white.svg', label: 'Mini Bus Taxi (White)', color: 'white', type: 'mini-bus' },
  { name: 'mini-bus-grey.svg', label: 'Mini Bus Taxi (Grey)', color: 'grey', type: 'mini-bus' },
  { name: 'mini-bus-bluegrey.svg', label: 'Mini Bus Taxi (Blue-grey)', color: 'bluegrey', type: 'mini-bus' },
  { name: 'mini-bus-yellow.svg', label: 'Mini Bus Taxi (Yellow)', color: 'yellow', type: 'mini-bus' },
  { name: 'mini-bus-orange.svg', label: 'Mini Bus Taxi (Orange)', color: 'orange', type: 'mini-bus' },
  { name: 'mini-bus-red.svg', label: 'Mini Bus Taxi (Red)', color: 'red', type: 'mini-bus' },
  { name: 'mini-bus-green.svg', label: 'Mini Bus Taxi (Green)', color: 'green', type: 'mini-bus' },
  { name: 'mini-bus-blue.svg', label: 'Mini Bus Taxi (Blue)', color: 'blue', type: 'mini-bus' },

  { name: 'coe-4ton-white.svg', label: 'COE 4-ton (White)', color: 'white', type: 'coe-4ton' },
  { name: 'coe-4ton-grey.svg', label: 'COE 4-ton (Grey)', color: 'grey', type: 'coe-4ton' },
  { name: 'coe-4ton-bluegrey.svg', label: 'COE 4-ton (Blue-grey)', color: 'bluegrey', type: 'coe-4ton' },
  { name: 'coe-4ton-yellow.svg', label: 'COE 4-ton (Yellow)', color: 'yellow', type: 'coe-4ton' },
  { name: 'coe-4ton-orange.svg', label: 'COE 4-ton (Orange)', color: 'orange', type: 'coe-4ton' },
  { name: 'coe-4ton-red.svg', label: 'COE 4-ton (Red)', color: 'red', type: 'coe-4ton' },
  { name: 'coe-4ton-green.svg', label: 'COE 4-ton (Green)', color: 'green', type: 'coe-4ton' },
  { name: 'coe-4ton-blue.svg', label: 'COE 4-ton (Blue)', color: 'blue', type: 'coe-4ton' },

  { name: 'coe-4ton-refrigerated-white.svg', label: 'COE 4-ton / Refrigerated (White)', color: 'white', type: 'coe-4ton-refrigerated' },
  { name: 'coe-4ton-refrigerated-grey.svg', label: 'COE 4-ton / Refrigerated (Grey)', color: 'grey', type: 'coe-4ton-refrigerated' },
  { name: 'coe-4ton-refrigerated-bluegrey.svg', label: 'COE 4-ton / Refrigerated (Blue-grey)', color: 'bluegrey', type: 'coe-4ton-refrigerated' },
  { name: 'coe-4ton-refrigerated-yellow.svg', label: 'COE 4-ton / Refrigerated (Yellow)', color: 'yellow', type: 'coe-4ton-refrigerated' },
  { name: 'coe-4ton-refrigerated-orange.svg', label: 'COE 4-ton / Refrigerated (Orange)', color: 'orange', type: 'coe-4ton-refrigerated' },
  { name: 'coe-4ton-refrigerated-red.svg', label: 'COE 4-ton / Refrigerated (Red)', color: 'red', type: 'coe-4ton-refrigerated' },
  { name: 'coe-4ton-refrigerated-green.svg', label: 'COE 4-ton / Refrigerated (Green)', color: 'green', type: 'coe-4ton-refrigerated' },
  { name: 'coe-4ton-refrigerated-blue.svg', label: 'COE 4-ton / Refrigerated (Blue)', color: 'blue', type: 'coe-4ton-refrigerated' },

  { name: 'medium-truck-white.svg', label: 'Medium Truck (White)', color: 'white', type: 'medium-truck' },
  { name: 'medium-truck-grey.svg', label: 'Medium Truck (Grey)', color: 'grey', type: 'medium-truck' },
  { name: 'medium-truck-bluegrey.svg', label: 'Medium Truck (Blue-grey)', color: 'bluegrey', type: 'medium-truck' },
  { name: 'medium-truck-yellow.svg', label: 'Medium Truck (Yellow)', color: 'yellow', type: 'medium-truck' },
  { name: 'medium-truck-orange.svg', label: 'Medium Truck (Orange)', color: 'orange', type: 'medium-truck' },
  { name: 'medium-truck-red.svg', label: 'Medium Truck (Red)', color: 'red', type: 'medium-truck' },
  { name: 'medium-truck-green.svg', label: 'Medium Truck (Green)', color: 'green', type: 'medium-truck' },
  { name: 'medium-truck-blue.svg', label: 'Medium Truck (Blue)', color: 'blue', type: 'medium-truck' },

  { name: 'rv-white.svg', label: 'RV (White)', color: 'white', type: 'rv' },
  { name: 'rv-grey.svg', label: 'RV (Grey)', color: 'grey', type: 'rv' },
  { name: 'rv-bluegrey.svg', label: 'RV (Blue-grey)', color: 'bluegrey', type: 'rv' },
  { name: 'rv-yellow.svg', label: 'RV (Yellow)', color: 'yellow', type: 'rv' },
  { name: 'rv-orange.svg', label: 'RV (Orange)', color: 'orange', type: 'rv' },
  { name: 'rv-red.svg', label: 'RV (Red)', color: 'red', type: 'rv' },
  { name: 'rv-green.svg', label: 'RV (Green)', color: 'green', type: 'rv' },
  { name: 'rv-blue.svg', label: 'RV (Blue)', color: 'blue', type: 'rv' },

  { name: 'civ-bus-white.svg', label: 'Civilian Bus (White)', color: 'white', type: 'civ-bus' },
  { name: 'civ-bus-grey.svg', label: 'Civilian Bus (Grey)', color: 'grey', type: 'civ-bus' },
  { name: 'civ-bus-bluegrey.svg', label: 'Civilian Bus (Blue-grey)', color: 'bluegrey', type: 'civ-bus' },
  { name: 'civ-bus-yellow.svg', label: 'Civilian Bus (Yellow)', color: 'yellow', type: 'civ-bus' },
  { name: 'civ-bus-orange.svg', label: 'Civilian Bus (Orange)', color: 'orange', type: 'civ-bus' },
  { name: 'civ-bus-red.svg', label: 'Civilian Bus (Red)', color: 'red', type: 'civ-bus' },
  { name: 'civ-bus-green.svg', label: 'Civilian Bus (Green)', color: 'green', type: 'civ-bus' },
  { name: 'civ-bus-blue.svg', label: 'Civilian Bus (Blue)', color: 'blue', type: 'civ-bus' },

  { name: 'semi-heavy-horse-white.svg', label: 'Heavy Semi Horse (White)', color: 'white', type: 'semi-heavy-horse' },
  { name: 'semi-heavy-horse-grey.svg', label: 'Heavy Semi Horse (Grey)', color: 'grey', type: 'semi-heavy-horse' },
  { name: 'semi-heavy-horse-bluegrey.svg', label: 'Heavy Semi Horse (Blue-grey)', color: 'bluegrey', type: 'semi-heavy-horse' },
  { name: 'semi-heavy-horse-yellow.svg', label: 'Heavy Semi Horse (Yellow)', color: 'yellow', type: 'semi-heavy-horse' },
  { name: 'semi-heavy-horse-orange.svg', label: 'Heavy Semi Horse (Orange)', color: 'orange', type: 'semi-heavy-horse' },
  { name: 'semi-heavy-horse-red.svg', label: 'Heavy Semi Horse (Red)', color: 'red', type: 'semi-heavy-horse' },
  { name: 'semi-heavy-horse-green.svg', label: 'Heavy Semi Horse (Green)', color: 'green', type: 'semi-heavy-horse' },
  { name: 'semi-heavy-horse-blue.svg', label: 'Heavy Semi Horse (Blue)', color: 'blue', type: 'semi-heavy-horse' },

  { name: 'semi-heavy-trailer-white.svg', label: 'Heavy Semi Trailer (White)', color: 'white', type: 'semi-heavy-trailer' },
  { name: 'semi-heavy-trailer-grey.svg', label: 'Heavy Semi Trailer (Grey)', color: 'grey', type: 'semi-heavy-trailer' },
  { name: 'semi-heavy-trailer-bluegrey.svg', label: 'Heavy Semi Trailer (Blue-grey)', color: 'bluegrey', type: 'semi-heavy-trailer' },
  { name: 'semi-heavy-trailer-yellow.svg', label: 'Heavy Semi Trailer (Yellow)', color: 'yellow', type: 'semi-heavy-trailer' },
  { name: 'semi-heavy-trailer-orange.svg', label: 'Heavy Semi Trailer (Orange)', color: 'orange', type: 'semi-heavy-trailer' },
  { name: 'semi-heavy-trailer-red.svg', label: 'Heavy Semi Trailer (Red)', color: 'red', type: 'semi-heavy-trailer' },
  { name: 'semi-heavy-trailer-green.svg', label: 'Heavy Semi Trailer (Green)', color: 'green', type: 'semi-heavy-trailer' },
  { name: 'semi-heavy-trailer-blue.svg', label: 'Heavy Semi Trailer (Blue)', color: 'blue', type: 'semi-heavy-trailer' },

  { name: 'semi-heavy-tanker-white.svg', label: 'Heavy Semi Tanker (White)', color: 'white', type: 'semi-heavy-tanker' },
  { name: 'semi-heavy-tanker-grey.svg', label: 'Heavy Semi Tanker (Grey)', color: 'grey', type: 'semi-heavy-tanker' },
  { name: 'semi-heavy-tanker-bluegrey.svg', label: 'Heavy Semi Tanker (Blue-grey)', color: 'bluegrey', type: 'semi-heavy-tanker' },
  { name: 'semi-heavy-tanker-yellow.svg', label: 'Heavy Semi Tanker (Yellow)', color: 'yellow', type: 'semi-heavy-tanker' },
  { name: 'semi-heavy-tanker-orange.svg', label: 'Heavy Semi Tanker (Orange)', color: 'orange', type: 'semi-heavy-tanker' },
  { name: 'semi-heavy-tanker-red.svg', label: 'Heavy Semi Tanker (Red)', color: 'red', type: 'semi-heavy-tanker' },
  { name: 'semi-heavy-tanker-green.svg', label: 'Heavy Semi Tanker (Green)', color: 'green', type: 'semi-heavy-tanker' },
  { name: 'semi-heavy-tanker-blue.svg', label: 'Heavy Semi Tanker (Blue)', color: 'blue', type: 'semi-heavy-tanker' },

  { name: 'coe-heavy-horse-white.svg', label: 'Heavy COE Horse (White)', color: 'white', type: 'coe-heavy-horse' },
  { name: 'coe-heavy-horse-grey.svg', label: 'Heavy COE Horse (Grey)', color: 'grey', type: 'coe-heavy-horse' },
  { name: 'coe-heavy-horse-bluegrey.svg', label: 'Heavy COE Horse (Blue-grey)', color: 'bluegrey', type: 'coe-heavy-horse' },
  { name: 'coe-heavy-horse-yellow.svg', label: 'Heavy COE Horse (Yellow)', color: 'yellow', type: 'coe-heavy-horse' },
  { name: 'coe-heavy-horse-orange.svg', label: 'Heavy COE Horse (Orange)', color: 'orange', type: 'coe-heavy-horse' },
  { name: 'coe-heavy-horse-red.svg', label: 'Heavy COE Horse (Red)', color: 'red', type: 'coe-heavy-horse' },
  { name: 'coe-heavy-horse-green.svg', label: 'Heavy COE Horse (Green)', color: 'green', type: 'coe-heavy-horse' },
  { name: 'coe-heavy-horse-blue.svg', label: 'Heavy COE Horse (Blue)', color: 'blue', type: 'coe-heavy-horse' },

  { name: 'coe-heavy-trailer-white.svg', label: 'Heavy COE Trailer (White)', color: 'white', type: 'coe-heavy-trailer' },
  { name: 'coe-heavy-trailer-grey.svg', label: 'Heavy COE Trailer (Grey)', color: 'grey', type: 'coe-heavy-trailer' },
  { name: 'coe-heavy-trailer-bluegrey.svg', label: 'Heavy COE Trailer (Blue-grey)', color: 'bluegrey', type: 'coe-heavy-trailer' },
  { name: 'coe-heavy-trailer-yellow.svg', label: 'Heavy COE Trailer (Yellow)', color: 'yellow', type: 'coe-heavy-trailer' },
  { name: 'coe-heavy-trailer-orange.svg', label: 'Heavy COE Trailer (Orange)', color: 'orange', type: 'coe-heavy-trailer' },
  { name: 'coe-heavy-trailer-red.svg', label: 'Heavy COE Trailer (Red)', color: 'red', type: 'coe-heavy-trailer' },
  { name: 'coe-heavy-trailer-green.svg', label: 'Heavy COE Trailer (Green)', color: 'green', type: 'coe-heavy-trailer' },
  { name: 'coe-heavy-trailer-blue.svg', label: 'Heavy COE Trailer (Blue)', color: 'blue', type: 'coe-heavy-trailer' },

  { name: 'coe-heavy-tanker-white.svg', label: 'Heavy COE Tanker (White)', color: 'white', type: 'coe-heavy-tanker' },
  { name: 'coe-heavy-tanker-grey.svg', label: 'Heavy COE Tanker (Grey)', color: 'grey', type: 'coe-heavy-tanker' },
  { name: 'coe-heavy-tanker-bluegrey.svg', label: 'Heavy COE Tanker (Blue-grey)', color: 'bluegrey', type: 'coe-heavy-tanker' },
  { name: 'coe-heavy-tanker-yellow.svg', label: 'Heavy COE Tanker (Yellow)', color: 'yellow', type: 'coe-heavy-tanker' },
  { name: 'coe-heavy-tanker-orange.svg', label: 'Heavy COE Tanker (Orange)', color: 'orange', type: 'coe-heavy-tanker' },
  { name: 'coe-heavy-tanker-red.svg', label: 'Heavy COE Tanker (Red)', color: 'red', type: 'coe-heavy-tanker' },
  { name: 'coe-heavy-tanker-green.svg', label: 'Heavy COE Tanker (Green)', color: 'green', type: 'coe-heavy-tanker' },
  { name: 'coe-heavy-tanker-blue.svg', label: 'Heavy COE Tanker (Blue)', color: 'blue', type: 'coe-heavy-tanker' },

  { name: 'mining-dump-truck-white.svg', label: 'Mining Dump Truck (White)', color: 'white', type: 'mining-dump-truck' },
  { name: 'mining-dump-truck-grey.svg', label: 'Mining Dump Truck (Grey)', color: 'grey', type: 'mining-dump-truck' },
  { name: 'mining-dump-truck-bluegrey.svg', label: 'Mining Dump Truck (Blue-grey)', color: 'bluegrey', type: 'mining-dump-truck' },
  { name: 'mining-dump-truck-yellow.svg', label: 'Mining Dump Truck (Yellow)', color: 'yellow', type: 'mining-dump-truck' },
  { name: 'mining-dump-truck-orange.svg', label: 'Mining Dump Truck (Orange)', color: 'orange', type: 'mining-dump-truck' },
  { name: 'mining-dump-truck-red.svg', label: 'Mining Dump Truck (Red)', color: 'red', type: 'mining-dump-truck' },
  { name: 'mining-dump-truck-green.svg', label: 'Mining Dump Truck (Green)', color: 'green', type: 'mining-dump-truck' },
  { name: 'mining-dump-truck-blue.svg', label: 'Mining Dump Truck (Blue)', color: 'blue', type: 'mining-dump-truck' }
]

export let assetIconsMap = new Map()
assetIcons.forEach((assetIcon) => {
  assetIconsMap.set(assetIcon.name, assetIcon)
})

let markerIconsMap = new Map()

assetIcons.forEach((icon) => {
  const assetType = assetTypesMap.get(icon.type)
  markerIconsMap.set(icon.name, {
    url: require(`@/assets/svg/${icon.name}`),
    width: assetType.width,
    height: assetType.height,
    scaledWidth: assetType.width,
    scaledHeight: assetType.height,
    rotational: assetType.rotational,
    headingOffset: assetType.headingOffset
  })
})

markerIconsMap.set('blue-circle-arrow.svg', {
  url: require('@/assets/svg/blue-circle-arrow.svg'),
  width: 45,
  height: 45,
  scaledWidth: 45,
  scaledHeight: 45,
  rotational: true,
  headingOffset: 0
})

let assetMarkers = new Map()
let markerClickHandlers = new Map()

// labelStates can be used as a prefix to vehicle labels
// in order to show what state they are in (e.g. their current activity)
// noinspection HtmlUnknownAttribute
export const labelStates = {
  stopped: `<svg aria-hidden="true" data-prefix="fas" data-icon="stop-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" name="stopCircle" class="svg-inline--fa fa-stop-circle fa-w-16 fa-fw"><path fill="rgb(255,183,77)" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z" class=""></path></svg>`,
  moving: `<svg aria-hidden="true" data-prefix="fas" data-icon="play-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" name="playCircle" class="svg-inline--fa fa-play-circle fa-w-16 fa-fw"><path fill="rgb(0,255,0)" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z" class=""></path></svg>`
}

/**
 * Adds a vehicle/unit marker click handler with a specified identifier. If
 * the event handler with the identifier is already set, nothing will
 * be done.
 *
 * @param handlerId String
 * @param onClick function
 */
export const addMarkerClickHandler = (handlerId, onClick) => {
  if (!markerClickHandlers.has(handlerId)) {
    markerClickHandlers.set(handlerId, onClick)
  }
}

/**
 * Removes an existing marker click handler.
 *
 * @param handlerId String
 */
export const removeMarkerClickHandler = (handlerId) => {
  markerClickHandlers.delete(handlerId)
}

/**
 * Removes all marker click handlers.
 */
export const clearMarkerClickHandlers = () => {
  markerClickHandlers.clear()
}

/**
 * Creates or updates an asset's marker.
 *
 * @param map google.maps.Map
 * @param assetId Integer
 * @param assetType String 'vehicle' or 'unit'
 * @param markerName String
 * @param telemetry Object A GPS telemetry message
 * @param labelContent null|string
 * @param options Object
 */
export const setAssetMarker = (map, assetId, assetType, markerName, telemetry, labelContent = null, options = {}) => {
  const lookupId = `${assetId}-${assetType}`
  if (assetMarkers.has(lookupId)) {
    // Update the existing marker
    let marker = assetMarkers.get(lookupId)
    const position = new google.maps.LatLng(telemetry.gps.latitude, telemetry.gps.longitude)
    marker.setPosition(position)

    let img = document.querySelector('img[src="' + marker.iconUrl + '"]')
    if (img) {
      const markerProps = markerIconsMap.get(markerName)
      let heading
      if (markerProps.rotational) {
        heading = telemetry.gps.heading - markerProps.headingOffset
      } else {
        heading = markerProps.headingOffset
      }
      const originX = markerProps.scaledWidth / 2
      const originY = markerProps.scaledHeight / 2
      img.style.transform = `rotate(${heading}deg)`
      img.style.transformOrigin = `${originX}px ${originY}px`
    }

    if (marker.markerLabel !== null) {
      if (labelContent !== null) {
        marker.markerLabel.el.innerHTML = labelContent
      }

      marker.markerLabel.position = position
    }

    setSafeZoneCircle(map, marker, telemetry)
  } else {
    // Create a new marker
    const markerProps = markerIconsMap.get(markerName)
    const iconUrl = markerProps.url
    const uniqueIconUrl = `${iconUrl}#${lookupId}`

    let position = new google.maps.LatLng(telemetry.gps.latitude, telemetry.gps.longitude)

    let marker = new google.maps.Marker({
      position: position,
      map: map,
      optimized: false,
      zIndex: 10,
      icon: {
        url: uniqueIconUrl,
        // anchor must be half of the scaled size
        anchor: new google.maps.Point(markerProps.scaledWidth / 2, markerProps.scaledHeight / 2),
        size: new google.maps.Size(markerProps.width, markerProps.height),
        scaledSize: new google.maps.Size(markerProps.scaledWidth, markerProps.scaledHeight)
      }
    })

    marker.assetId = assetId
    marker.assetType = assetType
    marker.iconUrl = uniqueIconUrl
    marker.safeZone = null

    markerClickHandlers.forEach((onClick) => {
      google.maps.event.addListener(marker, 'click', onClick)
    })

    if (labelContent !== null) {
      // Note: Calling this function will add a markerLabel property
      // to the marker object containing the label element
      mapUtils.createMarkerLabel(map, position, labelContent, marker, options)
    } else {
      marker.markerLabel = null
    }

    setSafeZoneCircle(map, marker, telemetry)
    assetMarkers.set(lookupId, marker)

    let heading
    if (markerProps.rotational) {
      heading = telemetry.gps.heading - markerProps.headingOffset
    } else {
      heading = markerProps.headingOffset
    }

    const originX = markerProps.scaledWidth / 2
    const originY = markerProps.scaledHeight / 2

    // This code is an to attempt to adjust the icon to the correct angle
    // shortly after it is shown for the first time on screen. Google maps
    // loads the icon asynchronously and only once or if its visibility is set
    // to true. This is only really required for the first time the image has
    // loaded as the images are cached.
    let displayIntervalCount = 0
    let displayInterval = setInterval(() => {
      let img = document.querySelector('img[src="' + marker.iconUrl + '"]')
      if (img) {
        img.style.transform = `rotate(${heading}deg)`
        img.style.transformOrigin = `${originX}px ${originY}px`
        clearInterval(displayInterval)
      } else if (displayIntervalCount > 40) {
        // We waited longer than a second, cancel the timer
        clearInterval(displayInterval)
      }

      displayIntervalCount += 1
    }, 25)
  }
}

const setSafeZoneCircle = (map, marker, telemetry) => {
  if (!telemetry.hasOwnProperty('safe_zone')) {
    removeSafeZoneCircle(marker)
    return
  }

  if (telemetry.safe_zone === null) {
    removeSafeZoneCircle(marker)
    return
  }

  if (telemetry.safe_zone.state === 'disabled' || telemetry.safe_zone.state === 'clear') {
    removeSafeZoneCircle(marker)
    return
  }

  let color = '#BDBDBD'
  switch (telemetry.safe_zone.state) {
    case 'created':
      color = '#B2DFDB'
      break

    case 'enabled':
      color = '#4DD0E1'
      break

    case 'triggered':
      color = '#F44336'
      break
  }

  if (marker.safeZone !== null) {
    // Update the existing safe zone circle and return
    marker.safeZone.setOptions({
      strokeColor: color,
      strokeOpacity: 1.0,
      strokeWeight: 2.0,
      fillColor: color,
      fillOpacity: 0.75,
      clickable: false,
      center: { lat: telemetry.safe_zone.latitude, lng: telemetry.safe_zone.longitude },
      radius: telemetry.safe_zone.radius
    })

    return
  }

  // else, create a new safe zone circle
  marker.safeZone = new google.maps.Circle({
    strokeColor: color,
    strokeOpacity: 1.0,
    strokeWeight: 2.0,
    fillColor: color,
    fillOpacity: 0.75,
    clickable: false,
    map,
    center: { lat: telemetry.safe_zone.latitude, lng: telemetry.safe_zone.longitude },
    radius: telemetry.safe_zone.radius
  })
}

const removeSafeZoneCircle = (marker) => {
  if (marker.safeZone !== null) {
    marker.safeZone.setMap(null)
    marker.safeZone = null
  }
}

/**
 * Returns the asset's marker or null if not found.
 *
 * @param assetId Integer
 * @param assetType String 'vehicle' or 'unit'
 *
 * @return google.maps.Marker|null
 */
export const getAssetMarker = (assetId, assetType) => {
  if (assetMarkers.has(`${assetId}-${assetType}`)) {
    return assetMarkers.get(`${assetId}-${assetType}`)
  } else {
    return null
  }
}

/**
 * Remove an existing asset's marker.
 *
 * @param assetId Integer
 * @param assetType String 'vehicle' or 'unit'
 */
export const removeAssetMarker = (assetId, assetType) => {
  const lookupId = `${assetId}-${assetType}`

  if (assetMarkers.has(lookupId)) {
    let marker = assetMarkers.get(lookupId)

    if (marker.markerLabel !== null) {
      marker.markerLabel.el.parentNode.removeChild(marker.markerLabel.el)
      marker.markerLabel.setMap(null)
      marker.markerLabel.marker = null
      marker.markerLabel = null
    }

    if (marker.safeZone !== null) {
      marker.safeZone.setMap(null)
      marker.safeZone = null
    }

    marker.setMap(null)
    assetMarkers.delete(lookupId)
  }
}

/**
 * Removes all asset markers.
 *
 */
export const clearAssetMarkers = () => {
  assetMarkers.forEach((marker) => {
    if (marker.markerLabel !== null) {
      marker.markerLabel.el.parentNode.removeChild(marker.markerLabel.el)
      marker.markerLabel.setMap(null)
      marker.markerLabel.marker = null
      marker.markerLabel = null
    }

    marker.setMap(null)
  })

  assetMarkers.clear()
}

/**
 * Sets the opacity of all markers
 */
export const setAllMarkersOpacity = (opacity) => {
  assetMarkers.forEach((marker) => {
    marker.setOpacity(opacity)
    if (marker.markerLabel !== null) {
      marker.markerLabel.el.style.opacity = opacity
    }
  })
}

/**
 * Hides all asset markers by setting their visible property to false.
 */
export const hideAssetMarkers = () => {
  assetMarkers.forEach((marker) => {
    marker.setVisible(false)
  })
}

/**
 * Shows all asset markers by setting their visible property to true.
 */
export const showAssetMarkers = () => {
  assetMarkers.forEach((marker) => {
    marker.setVisible(true)
  })
}

/**
 * Creates or updates the target marker.
 *
 * @param map google.maps.Map
 * @param telemetry Object A GPS telemetry message
 */
export const setTargetMarker = (map, telemetry) => {
  if (lockOnTarget.marker !== null) {
    lockOnTarget.marker.setPosition(new google.maps.LatLng(telemetry.gps.latitude, telemetry.gps.longitude))
  } else {
    lockOnTarget.url = require('@/assets/svg/target-yellow.svg') + '#target-marker'
    lockOnTarget.marker = new google.maps.Marker({
      position: new google.maps.LatLng(telemetry.gps.latitude, telemetry.gps.longitude),
      map: map,
      optimized: false,
      clickable: false,
      draggable: false,
      opacity: 1.0,
      zIndex: 20,
      icon: {
        url: lockOnTarget.url,
        // anchor must be half of the scaled size
        anchor: new google.maps.Point(10, 10),
        size: new google.maps.Size(20, 20),
        scaledSize: new google.maps.Size(20, 20)
      }
    })

    lockOnTarget.timer = setInterval(() => {
      if (lockOnTarget.image === null && lockOnTarget.url !== null) {
        lockOnTarget.image = document.querySelector('img[src="' + lockOnTarget.url + '"]')
      }

      if (lockOnTarget.image !== null) {
        lockOnTarget.angle += 5
        if (lockOnTarget.angle >= 360) {
          lockOnTarget.angle = 0
        }
        lockOnTarget.image.style.transform = 'rotate(' + lockOnTarget.angle + 'deg)'
      }
    }, 250)
  }
}

/**
 * Clear the target marker
 *
 */
export const clearTargetMarker = () => {
  if (lockOnTarget.marker !== null) {
    lockOnTarget.marker.setMap(null)
    lockOnTarget.marker = null
    lockOnTarget.image = null

    if (lockOnTarget.timer !== null) {
      clearInterval(lockOnTarget.timer)
    }
  }
}



// WEBPACK FOOTER //
// ./src/maps/google/assetMarkers.js